<template>
    <div class="student-type-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <!-- 筛选区 -->
            <div class="search-box">
                <el-select v-model="filterForm.province" multiple placeholder="全部省份" style="width: 200px;" clearable>
                    <el-option v-for="item in provinceOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.kl" multiple placeholder="全部科类" style="width: 200px;" clearable>
                    <el-option v-for="item in klOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.pc" multiple placeholder="全部批次" style="width: 200px;" clearable>
                    <el-option v-for="item in pcOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.major" multiple placeholder="全部专业" style="width: 200px;" clearable>
                    <el-option v-for="item in majorOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                <el-button @click="resetFilter">重置</el-button>
            </div>

            <!-- 分析文字 -->
            <div class="section-block">
                <p v-if="analysisText" v-html="analysisText"></p>
            </div>

            <!-- 直方图 -->
            <div class="section-block">
                <div class="chart-wrapper">
                    <div class="chart-controls-right">
                        <el-button size="mini" icon="el-icon-download" @click="downloadBar">下载图片</el-button>
                    </div>
                    <v-chart ref="barChart" :option="barOption" style="height: 350px;" autoresize></v-chart>
                </div>
            </div>

            <!-- 详情表格 -->
            <div class="section-block">
                <div class="section-header">
                    <h3 class="section-title">考生类别详情</h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
                </div>
                <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="College" label="学院" min-width="150" align="center" :filters="collegeFilters" :filter-method="filterCollege"></el-table-column>
                            <el-table-column prop="MajorName" label="专业" min-width="200" align="center"></el-table-column>
                            <el-table-column prop="TotalCount" label="总计" min-width="100" align="center"></el-table-column>
                            
                            <!-- 动态列出所有考生类别 -->
                            <el-table-column v-for="type in studentTypes" :key="type" :label="type" align="center">
                                <el-table-column :label="'人数'" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row['Type_' + type + '_Count'] || 0 }}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="'比例'" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row['Type_' + type + '_Ratio'] ? scope.row['Type_' + type + '_Ratio'].toFixed(2) + '%' : '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import VChart from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';

export default {
    name: 'StudentTypeAnalysis',
    components: {
        VChart
    },
    inject: ['Loading', 'LoadingCompleted'],
    data() {
        return {
            Status: {
                LoadingCompleted: false
            },
            loading: false,
            filterForm: {
                province: [],
                kl: [],
                pc: [],
                major: []
            },
            provinceOptions: [],
            klOptions: [],
            pcOptions: [],
            majorOptions: [],
            tableData: [],
            studentTypes: [],
            analysisText: '',
            year: 0,
            totalCount: 0,
            barOption: {},
            collegeFilters: []
        };
    },
    methods: {
        loadFilters() {
            const that = this;
            const api_name = '/Analysis/GetStudentTypeFilters';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading: false })
                .then(result => {
                    that.provinceOptions = result.data.ProvinceOptions;
                    that.klOptions = result.data.KlOptions;
                    that.pcOptions = result.data.PcOptions;
                    that.majorOptions = result.data.MajorOptions;
                });
        },
        loadData() {
            const that = this;
            that.loading = true;

            const api_name = '/Analysis/GetStudentTypeData';
            let url = TYBM_Env.GetApiUrl(api_name);

            const params = [];
            if (that.filterForm.province && that.filterForm.province.length > 0) {
                params.push('Province=' + encodeURIComponent(that.filterForm.province.join(',')));
            }
            if (that.filterForm.kl && that.filterForm.kl.length > 0) {
                params.push('Kl=' + encodeURIComponent(that.filterForm.kl.join(',')));
            }
            if (that.filterForm.pc && that.filterForm.pc.length > 0) {
                params.push('PC=' + encodeURIComponent(that.filterForm.pc.join(',')));
            }
            if (that.filterForm.major && that.filterForm.major.length > 0) {
                params.push('Major=' + encodeURIComponent(that.filterForm.major.join(',')));
            }
            if (params.length > 0) {
                url += '?' + params.join('&');
            }

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.StatList;
                    that.studentTypes = result.data.StudentTypes;
                    that.totalCount = result.data.TotalCount;
                    that.year = result.data.Year;
                    
                    if (that.provinceOptions.length === 0) {
                        that.loadFilters();
                    }

                    that.collegeFilters = [...new Set(that.tableData.map(item => item.College).filter(c => c))].map(c => ({ text: c, value: c }));

                    that.generateAnalysisText();
                    that.generateBarChart();
                    that.Status.LoadingCompleted = true;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        resetFilter() {
            this.filterForm.province = [];
            this.filterForm.kl = [];
            this.filterForm.pc = [];
            this.filterForm.major = [];
            this.loadData();
        },
        generateAnalysisText() {
            const that = this;
            if (!that.studentTypes || that.studentTypes.length === 0) {
                that.analysisText = '';
                return;
            }

            // 统计各类别总数
            const typeCounts = {};
            that.studentTypes.forEach(type => {
                typeCounts[type] = 0;
            });
            
            that.tableData.forEach(row => {
                that.studentTypes.forEach(type => {
                    typeCounts[type] += row['Type_' + type + '_Count'] || 0;
                });
            });

            // 按人数排序
            const sortedTypes = Object.keys(typeCounts).sort((a, b) => typeCounts[b] - typeCounts[a]);
            const typeTexts = sortedTypes.map(type => {
                const count = typeCounts[type];
                const ratio = that.totalCount > 0 ? (count / that.totalCount * 100).toFixed(2) : 0;
                return `${type}有${count}人，占比${ratio}%`;
            }).join('；');

            that.analysisText = `${that.year}年共录取${that.totalCount}人，其中${typeTexts}。`;
        },
        generateBarChart() {
            const that = this;
            
            // 统计各类别总数
            const typeCounts = {};
            that.studentTypes.forEach(type => {
                typeCounts[type] = 0;
            });
            
            that.tableData.forEach(row => {
                that.studentTypes.forEach(type => {
                    typeCounts[type] += row['Type_' + type + '_Count'] || 0;
                });
            });

            const types = Object.keys(typeCounts);
            const counts = types.map(type => typeCounts[type]);

            that.barOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '15%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: types,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                        fontSize: 12
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        type: 'bar',
                        data: counts,
                        barMaxWidth: 60,
                        itemStyle: {
                            color: '#67C23A'
                        },
                        label: {
                            show: true,
                            position: 'top',
                            fontSize: 12
                        }
                    }
                ]
            };
        },
        downloadBar() {
            const chart = this.$refs.barChart;
            if (chart) {
                const url = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff'
                });
                const link = document.createElement('a');
                link.download = `考生类别分布_${this.year}.png`;
                link.href = url;
                link.click();
            }
        },
        filterCollege(value, row) {
            return row.College === value;
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["序号", "学院", "专业", "总计"];
            that.studentTypes.forEach(type => {
                headers.push(type + '-人数');
                headers.push(type + '-比例');
            });
            csvContent += headers.join(",") + "\n";

            that.tableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.College || '-',
                    row.MajorName,
                    row.TotalCount
                ];
                that.studentTypes.forEach(type => {
                    rowData.push(row['Type_' + type + '_Count'] || 0);
                    rowData.push(row['Type_' + type + '_Ratio'] ? row['Type_' + type + '_Ratio'].toFixed(2) + '%' : '-');
                });
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `考生类别详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        this.$root.$on('global-year-change', this.loadData);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.loadData);
    }
};
</script>

<style scoped>
.student-type-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    align-items: center;
    flex-wrap: wrap;
}

.section-block {
    margin-bottom: 0px;
    background: white;
    border-radius: 8px;
    padding: 5px;
}

.section-title {
    margin: 0 0 12px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.chart-wrapper {
    position: relative;
    margin-top: 40px;
}

.chart-controls-right {
    position: absolute;
    right: 10px;
    top: -30px;
    z-index: 10;
    display: flex;
    gap: 10px;
    align-items: center;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
    width: 100%;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table-body >>> .el-table .cell {
    padding: 0 8px;
}
</style>

